<div *ngIf="isPageReady && address">
  <!-- COMPACT LAYOUT: 4 rows -->
  <div *ngIf="compact" class="flex flex-col w-full">
    <!-- Row 1: Address Name + Validate button -->
    <div class="flex">
      <div class="w-9/12 pb-3 pr-3">
        <prox-field label="Address Name">
          <input type="text" pInputText autocomplete="off" maxlength="50" [(ngModel)]="address.name" [bzModel]="parentEntity"
            [name]="pathify('name')" [disabled]="!!disabled" />
        </prox-field>
      </div>
      <div class="w-3/12">
        <prox-field label="&nbsp;">
          <button (click)="validate()" pButton type="button" class="p-button-raised p-button-sm"
            [disabled]="!!disabled"> Validate Address
          </button>
        </prox-field>
      </div>
    </div>
    <!-- Row 2: Address Line 1 + Address Line 2 -->
    <div class="flex">
      <div class="w-1/2 pb-3 pr-3">
        <prox-field label="Address Line 1">
          <input type="text" pInputText autocomplete="off" maxlength="50" [(ngModel)]="address.line1" [bzModel]="parentEntity"
            [name]="pathify('line1')" [disabled]="!!disabled" />
        </prox-field>
      </div>
      <div class="w-1/2 pb-3 pr-3">
        <prox-field label="Address Line 2">
          <input type="text" pInputText autocomplete="off" maxlength="50" [(ngModel)]="address.line2" [bzModel]="parentEntity"
            [name]="pathify('line2')" [disabled]="!!disabled" />
        </prox-field>
      </div>
    </div>
    <!-- Row 3: Address Line 3 + City + State + Zip -->
    <div class="flex">
      <div class="w-1/2 pb-3 pr-3">
        <prox-field label="Address Line 3">
          <input type="text" pInputText autocomplete="off" maxlength="50" [(ngModel)]="address.line3" [bzModel]="parentEntity"
            [name]="pathify('line3')" [disabled]="!!disabled" />
        </prox-field>
      </div>
      <div class="w-1/4 pb-3 pr-3">
        <prox-field label="City">
          <input type="text" pInputText autocomplete="off" maxlength="50" [(ngModel)]="address.city" [bzModel]="parentEntity"
            [name]="pathify('city')" [disabled]="!!disabled" />
        </prox-field>
      </div>
      <div class="w-1/8 pb-3 pr-3">
        <prox-field label="State">
          <p-select [options]="usStates" optionLabel="name" optionValue="abbr" [(ngModel)]="address.state"
            [bzModel]="parentEntity" [name]="pathify('state')" [disabled]="!!disabled" class="w-full">
          </p-select>
        </prox-field>
      </div>
      <div class="w-1/8 pb-3 pr-3">
        <prox-field label="Zip">
          <input type="text" pInputText autocomplete="off" maxlength="10" [(ngModel)]="address.zipcode" [bzModel]="parentEntity"
            [name]="pathify('zipcode')" [disabled]="!!disabled" />
        </prox-field>
      </div>
    </div>
    <!-- Row 4: Contact E-Mail (optional) -->
    <div *ngIf="showContactEmail" class="w-full pb-3 pr-3">
      <prox-field label="Contact E-Mail" hint="Separate multiple addresses with semicolons">
        <input type="text" pInputText [(ngModel)]="address!.email" [bzModel]="parentEntity!" [disabled]="!!disabled"
          name="email" />
      </prox-field>
    </div>
  </div>

  <!-- STANDARD LAYOUT: 6 rows -->
  <div *ngIf="!compact" class="flex flex-col w-full">
    <div class="flex">
      <div class="w-9/12 pb-3 pr-3">
        <prox-field label="Address Name">
          <input type="text" pInputText autocomplete="off" maxlength="50" [(ngModel)]="address.name" [bzModel]="parentEntity"
            [name]="pathify('name')" [disabled]="!!disabled" />
        </prox-field>
      </div>
      <div class="w-3/12">
        <prox-field label="&nbsp;">
          <button (click)="validate()" pButton type="button" class="p-button-raised p-button-sm"
            [disabled]="!!disabled"> Validate Address
          </button>
        </prox-field>
      </div>
    </div>
    <div class="w-full pb-3 pr-3">
      <prox-field label="Address Line 1">
        <input type="text" pInputText autocomplete="off" maxlength="50" [(ngModel)]="address.line1" [bzModel]="parentEntity"
          [name]="pathify('line1')" [disabled]="!!disabled" />
      </prox-field>
    </div>
    <div class="w-full pb-3 pr-3">
      <prox-field label="Address Line 2">
        <input type="text" pInputText autocomplete="off" maxlength="50" [(ngModel)]="address.line2" [bzModel]="parentEntity"
          [name]="pathify('line2')" [disabled]="!!disabled" />
      </prox-field>
    </div>
    <div class="w-full pb-3 pr-3">
      <prox-field label="Address Line 3">
        <input type="text" pInputText autocomplete="off" maxlength="50" [(ngModel)]="address.line3" [bzModel]="parentEntity"
          [name]="pathify('line3')" [disabled]="!!disabled" />
      </prox-field>
    </div>
    <div class="flex">
      <div class="w-5/12 pb-3 pr-3">
        <prox-field label="City">
          <input type="text" pInputText autocomplete="off" maxlength="50" [(ngModel)]="address.city" [bzModel]="parentEntity"
            [name]="pathify('city')" [disabled]="!!disabled" />
        </prox-field>
      </div>
      <div class="w-1/3 pb-3 pr-3">
        <prox-field label="State">
          <p-select [options]="usStates" optionLabel="name" optionValue="abbr" [(ngModel)]="address.state"
            [bzModel]="parentEntity" [name]="pathify('state')" [disabled]="!!disabled" class="w-full">
          </p-select>
        </prox-field>
      </div>
      <div class="w-1/4 pb-3 pr-3">
        <prox-field label="Zip">
          <input type="text" pInputText autocomplete="off" maxlength="10" [(ngModel)]="address.zipcode" [bzModel]="parentEntity"
            [name]="pathify('zipcode')" [disabled]="!!disabled" />
        </prox-field>
      </div>
    </div>
    <div *ngIf="showContactEmail" class="w-full pb-3 pr-3">
      <prox-field label="Contact E-Mail" hint="Separate multiple addresses with semicolons">
        <input type="text" pInputText [(ngModel)]="address!.email" [bzModel]="parentEntity!" [disabled]="!!disabled"
          name="email" />
      </prox-field>
    </div>
  </div>
</div>